import React, { useEffect } from 'react'
import { Button } from '@mui/material'
import selfscanning from '../../../Assets/selfscanning.png'
import { ReactComponent as Check } from '../../../Assets/check.svg'
import { ReactComponent as Left } from '../../../Assets/arrow-left.svg'
import '../innerpage.styles.scss'
import SeeAlso from '../../../Components/SeeAlso/SeeAlso'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

const SelfScanning = () => {
    const navigate = useNavigate();
        const {t} = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className='smartbip-contanier'>
            <div className='title-contanier'>
                <div className='title'>
                    <Button variant='text' onClick={() => navigate('/smartbip')} ><Left />{t("goback")}</Button>
                    <div className='small-title'>
                        {t("footer.selfscanning")}
                    </div>
                    <div className='big-title'>
                    {t("selfscanning.title1")}
                    </div>
                    <div className='subtitle'>
                    {t("selfscanning.subtitle")}
                    </div>
                </div>
                <div className='image'>
                    <img src={selfscanning} alt="selfscanning.png" />
                </div>
            </div>
            <div className='card-container'>
                <div className='card'>
                    <label className='title'>
                        {t("business")}
                    </label>
                    <div className='list-container'>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.business.check1")}</label>
                            </div>
                        </div>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.business.check2")}</label>
                            </div>
                        </div>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.business.check3")}</label>
                            </div>
                        </div>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.business.check4")}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <label className='title'>
                        {t("userPro")}
                    </label>
                    <div className='list-container'>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.user.check1")}</label>
                            </div>
                        </div>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.user.check2")}</label>
                            </div>
                        </div>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.user.check3")}</label>
                            </div>
                        </div>
                        <div className='list'>
                            <div>
                                <Check />
                            </div>
                            <div>
                                <label>{t("selfscanning.user.check4")}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='features'>
                <label className='bold' style={{ fontSize: '26px' }}>{t("features")}</label>
                <label>{t("features.subtitle")}</label>
                <div className='list-conainer'>
                    <div className='list'>
                        <div>
                            <Check />
                        </div>
                        <div className='label-container'>
                            <label className='bold' style={{ fontSize: '22px' }}>{t("selfscanning.features.check1.title")}</label>
                            <label>{t("selfscanning.features.check1.subtitle")}</label>
                        </div>
                    </div>
                    <div className='list'>
                        <div>
                            <Check />
                        </div>
                        <div className='label-container'>
                            <label className='bold' style={{ fontSize: '22px' }}>{t("selfscanning.features.check2.title")}</label>
                            <label>{t("selfscanning.features.check2.subtitle")}</label>
                        </div>
                    </div>
                    <div className='list'>
                        <div>
                            <Check />
                        </div>
                        <div className='label-container'>
                            <label className='bold' style={{ fontSize: '22px' }}>{t("selfscanning.features.check3.title")}</label>
                            <label>{t("selfscanning.features.check3.subtitle")}</label>
                        </div>
                    </div>
                </div>
            </div>
            <SeeAlso self />
        </div>
    )
}

export default SelfScanning